'use client';

import { useClientContext } from '@dealerportal/react-helpers';
import type { FC } from 'react';

interface BroadlumeLogoProps {
  title: string;
  imgSrc?: string;
  alt?: string;
  linkHref?: string;
  subtitle?: React.ReactNode;
}

const defaultProps = {
  src: 'https://res.cloudinary.com/force/image/upload/f_auto,q_auto,w_120/c_limit,w_120/v1/ff/powered-by-ff-light',
  href: 'https://www.broadlume.com',
} as const;

const potentialSubtitles: React.ReactNode[] = [
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      flooring software
    </a>{' '}
    company
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      flooring software
    </a>{' '}
    company
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites"
    >
      flooring website company
    </a>
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/seo"
    >
      flooring seo
    </a>{' '}
    company
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      flooring estimating software
    </a>{' '}
    company
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/digital-advertising"
    >
      flooring digital marketing
    </a>{' '}
    company
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/digital-advertising"
    >
      flooring marketing
    </a>{' '}
    company
  </>,
  <a
    style={{ fontSize: 'inherit', color: 'inherit' }}
    href="https://www.broadlume.com/products/websites"
  >
    Websites for flooring retailers
  </a>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      flooring business software
    </a>{' '}
    company
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/lead-management"
    >
      flooring CRM
    </a>{' '}
    & website company
  </>,
  <a
    style={{ fontSize: 'inherit', color: 'inherit' }}
    href="https://www.broadlume.com/products/flooring-software"
  >
    Software for flooring businesses
  </a>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      flooring software company
    </a>
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/seo"
    >
      flooring SEO company
    </a>
  </>,
  <a
    style={{ fontSize: 'inherit', color: 'inherit' }}
    href="https://www.broadlume.com/products/websites"
  >
    Websites for flooring dealers
  </a>,
  <a
    style={{ fontSize: 'inherit', color: 'inherit' }}
    href="https://www.broadlume.com/products/flooring-software"
  >
    Flooring business management software company
  </a>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      Floor covering software
    </a>{' '}
    company
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      flooring software program
    </a>
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites"
    >
      flooring website design
    </a>{' '}
    company
  </>,
  <>
    The
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      best flooring software
    </a>
  </>,
  <a
    style={{ fontSize: 'inherit', color: 'inherit' }}
    href="https://www.broadlume.com/products/flooring-software"
  >
    Retail flooring software
  </a>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      Flooring estimate software
    </a>{' '}
    & websites
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      flooring store software
    </a>{' '}
    company
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/lead-management"
    >
      flooring CRM software
    </a>{' '}
    & websites
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/flooring-visualizer"
    >
      flooring visualizer
    </a>{' '}
    & website company
  </>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software/inventory-management"
    >
      Flooring inventory management
    </a>{' '}
    & websites
  </>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software/integrated-accounting"
    >
      Flooring accounting
    </a>{' '}
    & websites
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/digital-advertising"
    >
      flooring advertising
    </a>{' '}
    & website company
  </>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/flooring-visualizer"
    >
      Flooring visualizer software{' '}
    </a>
    & websites
  </>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      Flooring management software
    </a>{' '}
    & websites
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      flooring retailer software
    </a>{' '}
    company
  </>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software"
    >
      Software for flooring
    </a>{' '}
    stores
  </>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software/inventory-management"
    >
      Flooring inventory software
    </a>{' '}
    & websites
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/digital-advertising"
    >
      flooring digital advertising
    </a>{' '}
    company
  </>,
  <>
    Websites &{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/lead-management"
    >
      lead management for flooring
    </a>
  </>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software/schedule-a-demo-flooring-product-pricing-software"
    >
      Flooring showroom pricing
    </a>{' '}
    & websites
  </>,
  <>
    Flooring{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software/schedule-a-demo-flooring-product-pricing-software"
    >
      showroom pricing
    </a>{' '}
    & websites
  </>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/retail-selling-system/in-store-visualization"
    >
      In-store flooring visualizer
    </a>{' '}
    & website company
  </>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/flooring-software/job-costing"
    >
      Flooring job costing
    </a>{' '}
    & websites
  </>,
  <>
    A{' '}
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/products/websites/digital-advertising"
    >
      flooring leads
    </a>{' '}
    & website company
  </>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="https://www.broadlume.com/digital-retailing"
    >
      Digital retailing
    </a>{' '}
    for flooring
  </>,
  <a
    style={{ fontSize: 'inherit', color: 'inherit' }}
    href="https://www.broadlume.com/digital-retailing"
  >
    Digital retailing for flooring
  </a>,
  <>
    <a
      style={{ fontSize: 'inherit', color: 'inherit' }}
      href="retail lead management"
    >
      Retail lead management
    </a>{' '}
    & websites
  </>,
];

function PickRandomSubtitle(clientId: number) {
  let state = (clientId + 0x6d2b79f5) | 0;
  state = Math.imul(state ^ (state >>> 15), state | 1);
  state ^= state + Math.imul(state ^ (state >>> 7), state | 61);
  const unit = ((state ^ (state >>> 14)) >>> 0) / 2 ** 32;
  return potentialSubtitles[Math.floor(unit * potentialSubtitles.length)];
}
export const BroadlumeLogo: FC<BroadlumeLogoProps> = (props) => {
  const clientContext = useClientContext();

  const companyName =
    clientContext.tokens.find((x) => x.TokenName === 'companyname')
      ?.Replacement ?? '';
  const primaryMarket =
    clientContext.tokens.find((x) => x.TokenName === 'PrimaryMarket')
      ?.Replacement ?? '';
  const titleAndAltText = `${companyName} in ${primaryMarket} is powered by Broadlume`;
  const subtitle =
    props.subtitle ?? PickRandomSubtitle(clientContext.clientId ?? 0);

  return (
    <figure className="ui-flex ui-flex-col ui-items-center">
      {props.linkHref ? (
        <a
          href={props.linkHref}
          title={props.title}
          // biome-ignore lint/a11y/noBlankTarget: <explanation>
          target="_blank"
        >
          <img
            src={props.imgSrc ?? defaultProps.src}
            alt={titleAndAltText}
            title={titleAndAltText}
          />
        </a>
      ) : (
        <div title={props.title}>
          <img
            src={props.imgSrc ?? defaultProps.src}
            alt={titleAndAltText}
            title={titleAndAltText}
          />
        </div>
      )}
      <figcaption className="ui-text-[8px] ui-text-[#EEA820] ui-mt-1.5">
        {subtitle}
      </figcaption>
    </figure>
  );
};

export default BroadlumeLogo;
